// components/Navbar.tsx
"use client";
import {
  Flex,
  Box,
  Button,
  Image,
  useDisclosure,
  Text,
  Show,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Portal
} from "@chakra-ui/react";
import Link from "next/link";
import DeepMode from "@public/DeepMode.svg";
import GoogleForm from "./GoogleForm";
import { useAppContext } from "hooks";
import { useRouter } from 'next/navigation';
import { ChevronDownIcon } from "@chakra-ui/icons";

const Navbarforhome = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { jwt } = useAppContext(); 
  const router = useRouter();
  // Assuming jwt is correctly provided by the context
  const handleStartCreatingClick = () => {
    if (jwt) {
      router.push('/dashboard');
    } else {
      onOpen();
    }
  };
  return (
    <>
      {/* Mobile, < 768px */}
      <Show below="md">
        <Flex zIndex={5} px="32px" align="center" mt="20px" justify="space-between">
          <Link href="/">
            <Image alt="DeepMode logo" w="128px" src={DeepMode.src} />
          </Link>
          <GoogleForm isOpen={isOpen} onClose={onClose} />
          <Flex align="center">
             {jwt ? (
              <Menu>
                <MenuButton
                  as={Button}
                  h="56px"
                  ml="24px"
                  px="24px"
                  color="white"
                  bg="#FF1B6D"
                  borderRadius="16px"
                  rightIcon={<ChevronDownIcon />}
                >
                  Menu
                </MenuButton>
                <Portal>
                  <MenuList
                    borderRadius="12px"
                    p="8px"
                    bg="gray.700"
                    border="1px solid #FF1B6D"
                    mt="12px"
                  >
                    <MenuItem
                      bg="transparent"
                      _hover={{ bg: "gray.600" }}
                      _focus={{ bg: "gray.600" }}
                      onClick={() => router.push("/dashboard")}
                    >
                      Dashboard
                    </MenuItem>
                    <MenuItem
                      bg="transparent"
                      _hover={{ bg: "gray.600" }}
                      _focus={{ bg: "gray.600" }}
                      onClick={() => router.push("/public-models")}
                    >
                      Public Models
                    </MenuItem>
                  </MenuList>
                </Portal>
              </Menu>
            ) : (
              <Button
                h="56px"
                ml="24px"
                px="24px"
                color="white"
                bg="#FF1B6D"
                borderRadius="16px"
                onClick={handleStartCreatingClick}
              >
                Sign Up
              </Button>
            )}
          </Flex>
          {/* Move GoogleForm component here */}
          <GoogleForm isOpen={isOpen} onClose={onClose} />
        </Flex>
      </Show>

      {/* Desktop, >= 768px */}
      <Show above="md">
        <Flex
          px={["25px", "35px", "40px", "60px", "60px", "15%"]}
          zIndex={5}
          mt="35px"
          w="100%"
          justify="space-between"
          align="center"
        >
          <Link href="/">
            <Image src={DeepMode.src} alt="DeepMode Logo" />
          </Link>
          <Flex w="100%" justify="end" align="center">
            {/* Dropdown Models Menu */}
            <Link href="/public-models">
              <Button
                px="24px"
                h="56px"
                borderRadius="16px"
                border="1px solid white"
                color="white"
                bg="transparent"
                _hover={{ bg: "transparent" }}
                _active={{ bg: "transparent" }}
                _focus={{ bg: "transparent" }}
              >
                <Text>Models</Text>
              </Button>
            </Link>
            {jwt ? (
              <Link href="/dashboard">
                <Button
                  h="56px"
                  ml="24px"
                  px="24px"
                  color="white"
                  bg="#FF1B6D"
                  borderRadius="16px"
                >
                  Dashboard
                </Button>
              </Link>
            ) : (
              <Button
                h="56px"
                ml="24px"
                px="24px"
                color="white"
                bg="#FF1B6D"
                borderRadius="16px"
                onClick={onOpen} // Opens the Google form
              >
                Sign Up
              </Button>
            )}
          </Flex>
          {/* Move GoogleForm component here */}
          <GoogleForm isOpen={isOpen} onClose={onClose} />
        </Flex>
      </Show>
    </>
  );
};

export default Navbarforhome;
